var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareAllButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 52,
    viewBox: "0 0 126 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 125,
    height: 51,
    rx: 9.5,
    stroke: "#1D314C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3883 19L35.1761 24.4145L34.8758 24.7264L35.1416 25.0682L41.3108 33H37.6182L33.1878 27.3038L32.8333 26.848L32.4329 27.264L26.9112 33H26.8419L32.5022 27.1202L32.8025 26.8082L32.5366 26.4664L26.7295 19H30.4221L34.4905 24.2309L34.8449 24.6866L35.2454 24.2706L40.319 19H40.3883ZM27.8503 19.0323H26.828L27.4556 19.8392L37.5166 32.7746L37.6667 32.9676H37.9113H40.1897H41.212L40.5843 32.1606L30.5234 19.2253L30.3732 19.0323H30.1287H27.8503Z",
    stroke: "#1D314C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4796 32.5V31.156H61.2876L62.1516 30.276V27.924L61.2876 27.044H56.7276L55.0636 25.38V22.388L56.7276 20.708H62.9996V22.052H57.3836L56.5036 22.932L56.5196 24.884L57.3836 25.764H61.9436L63.6076 27.444V30.82L61.9436 32.5H55.4796ZM66.5548 32.5V20.708H67.9628V25.46L69.2428 24.132H72.3308L73.9948 25.812V32.5H72.5868V26.164L71.7388 25.252H69.6108L67.9628 26.932V32.5H66.5548ZM78.0912 32.5L76.4272 30.82V28.916L78.0912 27.236H82.3472V26.196L81.4832 25.316H77.5152V24.132H82.0912L83.7552 25.812V32.5H82.3472V31.204L81.0512 32.5H78.0912ZM78.7152 31.38H80.6992L82.3472 29.748V28.34L78.7152 28.356L77.8352 29.22V30.5L78.7152 31.38ZM86.9442 32.5V24.132H88.3522V25.636L89.8082 24.132H91.9522V25.54H89.8722L88.3522 27.108V32.5H86.9442ZM95.4003 32.5L93.7203 30.82V25.812L95.4003 24.132H99.1283L100.808 25.812V28.836H95.1283V30.452L96.0083 31.332H100.664V32.5H95.4003ZM95.1283 27.716H99.4003V26.132L98.5203 25.252H96.0083L95.1283 26.132V27.716Z",
    fill: "#1D314C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareAllButton);
export default __webpack_public_path__ + "static/media/share-all-button.b7beda0e0641ac6c51250315f8a0ca2f.svg";
export { ForwardRef as ReactComponent };